import { useQuery } from '@tanstack/react-query';
import { getSlideRegistrations } from 'api/slideRegistrations';
import { size } from 'es-toolkit/compat';
import { CasesParams } from 'utils/useCasesParams/types';

export const useSlidesRegistrationsQuery = ({
  enabled = true,
  casesParamsForRegistrations,
  slideStainTypes,
}: {
  enabled?: boolean;
  casesParamsForRegistrations?: CasesParams;
  slideStainTypes: string[];
}) => {
  const canLoadRegistrations = Boolean(casesParamsForRegistrations) && size(slideStainTypes) > 1;
  const queryContext = useQuery({
    queryKey: ['slide_registrations', casesParamsForRegistrations],
    queryFn: () => getSlideRegistrations(casesParamsForRegistrations!),
    enabled: enabled && canLoadRegistrations,
  });
  return {
    ...queryContext,
    canLoadRegistrations,
  };
};
